import React									from 'react';

import Avatar									from './Avatar';
import Input									from '../Input';

import {useAppSelector}							from '../../../app/hooks';
import {ProfilePictureProps}					from './interface';

import img_addImage								from '../../images/icon/add-image.svg';

import LANGUAGE									from '../../language';

import './Avatar.css';


function ProfilePicture(props: ProfilePictureProps): JSX.Element {
	const lang = useAppSelector(state => state.settings.lang);

	const TEXTE = LANGUAGE(lang);

	function changeProfilPicture(files: FileList | null) {
		if (!files || !files[0])
			return;
		props.setProfilePictureFile(files[0]);

		const reader = new FileReader();
		reader.onload = e => props.setProfilePictureImg(e?.target?.result as string);
		reader.readAsDataURL(files[0]);
	}

	let forceImage = props.profilePictureImg;

	if (!forceImage && !props.user)
		forceImage = img_addImage;

	return (
		<div className={'profilePictureMainContainer'}>
			<span className={'weight-500'}>{TEXTE.users.profilPicture}</span>
			<div>
				<Avatar
					size={64}
					user={props.user}
					forceImage={forceImage}
					style={{backgroundSize: (props.profilePictureFile || !forceImage) ? 'contain' : '50%'}}
				/>
				<Input
					noIconFileInput
					type={'file'}
					onChangeFile={changeProfilPicture}
					fileInputText={TEXTE.users.avatarRules}
					accept={'gif,.jpg,.jpeg,.tiff,.png,.webp,.bmp'}
				/>
			</div>
		</div>
	);
}

export default ProfilePicture;